import { ErrorLogComponent } from '@cian/error-log-component';
import * as React from 'react';
import { Provider } from 'react-redux';
import { PageContainer } from '../PageContainer';
import { TReduxStore } from '../../types/redux';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { ICustomContextParams } from '../../types/ICustomContextParams';
import { uaToDeviceType } from '@cian/ui-kit/utils';
import { IApplicationContext } from '../../types/application';
import { Context as ApplicationContext } from '../../utils/withApplicationContext';

export interface IApplicationProps extends IApplicationContext {
  reduxStore: TReduxStore;
  customContext: ICustomContextParams;
}

export class Application extends React.Component<IApplicationProps> {
  public render() {
    const { logger, reduxStore, customContext, config } = this.props;

    return (
      <ApplicationContext.Provider value={{ config, logger }}>
        <ErrorLogComponent logger={logger}>
          <UiKitContextProvider deviceType={uaToDeviceType(customContext.userAgent)}>
            <Provider store={reduxStore}>
              <PageContainer />
            </Provider>
          </UiKitContextProvider>
        </ErrorLogComponent>
      </ApplicationContext.Provider>
    );
  }
}
